import React from 'react'

import { useConfig } from '../../../core'

export const getImageUrl = (path: string, imageHost?: string): string =>
  `${
    imageHost ? (imageHost.endsWith('/') ? imageHost : `${imageHost}/`) : ''
  }${path}`

type ImageMapperProps =
  | { name: string; images: string[] }
  | { name: string; image: string }

export type ImageMapper<T extends ImageMapperProps = ImageMapperProps> = (
  src: string,
  props: T,
  index: number,
) => {
  src: string
  alt: string
}

const defaultImageMapper: ImageMapper = <T extends { name: string }>(
  src: string,
  { name }: T,
  index: number,
) => {
  return {
    src: getImageUrl(src),
    alt: `${name} 画像${index + 1}`,
  }
}

export const useImageMapper = <T extends ImageMapperProps = ImageMapperProps>(
  props: T,
  imageMapper: ImageMapper<T> = defaultImageMapper,
) => {
  const { imageHost } = useConfig()

  return React.useMemo(() => {
    return (
      (props as { name: string; images: string[] }).images ?? [
        (props as { name: string; image: string }).image,
      ]
    ).map((img, i) => imageMapper(getImageUrl(img, imageHost), props, i))
  }, [imageHost, imageMapper, props])
}
